/*eslint-disable*/
import React, { Component } from 'react'
import { Header, Segment } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import moment from 'moment'
import Axios from 'axios';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';
import ViewButton from './viewButton'
import AgGridTable from '../agGridComponent/agGridTable';

export default class ApprovalTable extends Component {

    state = {
        jobcardData: [],
        jobCardId: '',
        areLoaded: false,
        onSelectedValue: false,
    }
    componentDidMount() {
        this.getApprovals()
    }
    getApprovals = () => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let roleId = localStorage.getItem('roleId')
        let role = localStorage.getItem('role')

        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                forApproval: '1',
                //roleId: 0,
                role: role,
                userId: userId
            })
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobcardList`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        }).then((response => {
            // console.log(response.data.data)
            this.setState({
                jobcardData: response.data.data,
                areLoaded: true

            })
        }))
            .catch(error => {
                console.log(error)
                this.setState({
                    areLoaded: true
                })
            })
    }
    handleSelect = (data) => {
        let selectedRows = data.api.getSelectedRows()
        let selectedRowIds = []
        if (selectedRows.length > 0) {
            selectedRows.map((object, index) => {
                let temp = {}
                temp.jobCardId = object.id
                selectedRowIds[index] = temp
            })
            this.props.selectedRowData(selectedRowIds)
            this.props.onSelected(true)
        } else {
            this.props.selectedRowData([])
            this.props.onSelected(false)
        }
    }
    render() {
        const { jobcardData, areLoaded } = this.state
        console.log(jobcardData,'jobcardData')
        if (jobcardData.length === 0 && areLoaded === false) {
            return (
                <LoadingPlaceholder />
            )
        } else {
            let columns = [
                { headerName: 'Jobcard No', field: 'number', headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true, tooltipField: 'number', checkbox: true, enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Created Date', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Reference No', field: 'refNum', tooltipField: 'refNum', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Vehicle No', field: 'vehnumber', tooltipField: 'vehnumber', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Jobcard Type', field: 'type', tooltipField: 'type', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Branch', field: 'branchName', tooltipField: 'branchName', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Vehicle In Date', field: 'vehicleIn', tooltipField: 'vehicleIn', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Vehicle Out Date', field: 'vehicleOut', cellRenderer: 'statusRenderer', tooltipField: 'vehicleOut', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Meter Reading', field: 'meterReading', tooltipField: 'meterReading', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Vendor', field: 'vendor', tooltipField: 'vendor', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'Total Amount', field: 'total', tooltipField: 'total', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: 'View', field: 'view', cellRenderer: 'actionRenderer', enableRowGroup: true, enablePivot: true, pinned: "right" }
            ]
            let rows = []
            jobcardData.map((object, index) => {
                let temp = {}
                temp.number = object.jobCardno
                temp.createdOn = object.createdOn !== null ? moment(object.createdOn).format('DD-MM-YYYY') : ''
                temp.refNum = object.refNo
                temp.id = object.jobCardId
                temp.appStatusId = object.approvalStatus
                temp.vehnumber = object.vehicle_obj && object.vehicle_obj.vehicleNo ? object.vehicle_obj.vehicleNo : ''
                temp.vehid = object.vehicle_obj && object.vehicle_obj.vehicleId ? object.vehicle_obj.vehicleId : ''
                temp.type = object.jb_type === null ? '' : (object.jb_type.jobCardType == 'BATTERY' || object.jb_type.jobCardType == 'TYRE') ? object.jb_type.jobCardType.concat(object?.jobcardActivityName ? "-" + object?.jobcardActivityName.split(' ')[0] : "") : object.jb_type.jobCardType
                temp.branchName = object.branch_obj ? object.branch_obj.branchName : ''
                temp.vehicleIn = object.vehicleInDate !== null ? moment(object.vehicleInDate).format('DD-MM-YYYY') : ''
                temp.vehicleOut = object.vehicleOutDate !== null ? moment(object.vehicleOutDate).format('DD-MM-YYYY') : ''
                temp.meterReading = object.meterReading
                temp.vendor = object?.vendor_obj?.vendorName ? object.vendor_obj.vendorName : ''
                temp.total = object.totalAmt ? ` ₹ ${object.totalAmt}` : ''
                temp.states = this.props.linkProps
                rows[index] = temp
            })

            return (
                <React.Fragment>
                    <AgGridTable
                        columnDefs={columns}
                        rowData={rows}
                        actionButton={ViewButton}
                        searchValue={this.props.searchValue}
                        // rowSelected={this.handleSelect}
                        onSelectionChanged={this.handleSelect}
                        approvalsSection={true}
                    />

                </React.Fragment>
            )
        }
    }
}
